import React from "react";
import FormButton from "stories/FormButton";
import { formatDate, UTCTimeConverter } from "utils";

const EpisodeBookSession = (props) => {
  const { handleRedirectToInstructorDetails, instructorInfo } = props;
  const formatedDateTime = `${formatDate(instructorInfo?.next_available_slot?.start_time,"DDMMYYYY")} - ${UTCTimeConverter(instructorInfo?.next_available_slot?.start_time)}`;
  const availableDate = instructorInfo?.next_available_slot? formatedDateTime: "No slot available";

  return (
    <div className="flex flex-col gap-2">
      <FormButton
        onClick={handleRedirectToInstructorDetails}
        className="rounded-lg h-[2.2rem] px-[1.2rem]"
      >
        Book Session
      </FormButton>
      <span className="font-[BWModelica-Regular] available-slot text-white text-[8px] md:text-[12px]">
        Available slot : {availableDate}
      </span>
    </div>
  );
};

export default EpisodeBookSession;
